import React from 'react';

const directions = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
const angleMap = {
   N: 0, NE: 45, E: 90, SE: 135, S: 180, SW: 225, W: 270, NW: 315
};

interface RosetteProps {
   selected: string[];
   onChange: (dirs: string[]) => void;
}

const Rosette: React.FC<RosetteProps> = ({ selected, onChange }) => {
   const toggle = (dir: string) => {
      if (selected.includes(dir)) {
         onChange(selected.filter(d => d !== dir));
      } else {
         onChange([...selected, dir]);
      }
   };

   return (
      <svg width="200" height="200" viewBox="0 0 200 200">
         <circle cx="100" cy="100" r="88" fill="#eee" stroke="#666" strokeWidth="2" />
         {directions.map(dir => {
            const angle = angleMap[dir];
            const rad = (angle - 90) * Math.PI / 180;
            const x = 100 + 65 * Math.cos(rad);
            const y = 100 + 65 * Math.sin(rad);
            return (
               <g key={dir} onClick={() => toggle(dir)} cursor="pointer">
                  <circle cx={x} cy={y} r="20" fill={selected.includes(dir) ? '#003049' : '#ccc'} />
                  <text x={x} y={y + 4} textAnchor="middle" fontSize="12" fill="#fff">{dir}</text>
               </g>
            );
         })}
      </svg>
   );
};

export default Rosette;
